import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  CkTextEditor,
  FormFieldSet,
  LogoLoader,
  Modal,
  showToast,
  useFormHandler,
} from "../../../../../components";
import { useDispatch, useSelector } from "react-redux";
import { addJobPosting, updateJobPosting } from "../../../../../redux/slices/accountDetails/accountDetailsAPi";
import { fetchAllRecruitersAndBDMUsers, fetchJobPost, userRefCount } from "../../../../../redux/slices/bdmjobs/bdmjobsApi";
import { trackEvent } from "../../../../../utils/mixpanelService";
import { getAllIntegrations, getAllIntegrationAccess } from "../../../../../redux/slices/setting/settingApi";
import { getRaSettingsStart } from "../../../../../redux/slices/leads/leadsSlice";

const AddJobPost = ({ onClose, data, onSuccess, editData,jobpostId,companyName  }) => {
  // console.log("Data",data)
  // console.log("editData",editData)
  const [isLoading, setIsLoading] = useState(false);
  const [loading,setLoading] = useState(false);
  const [jobData, setJobData] = useState(editData || {});
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const { user } = useSelector((state) => state?.auth);
  const jobCode = GenerateJobString(
    { userSudoFirstName: user?.data?.firstName },
    { companyName: data?.companyId?.[0]?.name }
  );
  const [jobDescription, setJobDescription] = useState(data?.description || "");
  const [allRecruiters, setAllRecruiters] = useState([]);
  const orgId = user?.data?.organizationId?.uiid;
  const [botConfirmModal, setBotConfirmModal] = useState(false);
  const [pendingBotAssignment, setPendingBotAssignment] = useState(null);
  const [maximumCalls, setMaximumCalls] = useState();
  const [talentMatchRadius, setTalentMatchRadius] = useState(50);
  const dispatch = useDispatch();
  const raSettings = useSelector((state) => state.leads?.raSettings?.data);
  // const jobData = editData || {};

  // const initialFormData = {
  //   jobCode: jobCode || "",
  //   jobTitle: data.title || "",
  //   jobStartDate: "",
  //   jobEndDate: "",
  //   remoteJob: "",
  //   //////
  //   ///Client Bill Rate / Salary and Pay Rate / Salary not added
  //   //////
  //   expensePaid: "",
  //   country: data.location?.country || "",
  //   state: data.location?.state || "",
  //   location: data.location?.city || "",
  //   jobType: "",
  //   ///////////
  //   requiredHourWeek: "",
  //   client: "",
  //   endClient: "",
  //   clientJobId: "",
  //   requiredDocuments: "",
  //   ///////////
  //   turnOutTime: "",
  //   turnOutTimeSelect: "",
  //   priority: "",
  //   duration: "",
  //   areaCode: "",
  //   workAuthorization: "",
  //   /////////
  //   clearance: "",
  //   address: "",
  //   /////////
  //   industry: "",
  //   experienceMin: "",
  //   experienceMax: "",
  //   primarySkills: "",
  //   languages: "",
  //   comments: "",
  //   ///////////////
  //   // organizationalIndustry: "",
  //   noOfPosition: "",
  //   taxTerms: "",
  //   assignedTo: "",
  //   notifyTo: "",
  //   // added payments
  //   payments: {
  //     billRate: {
  //       currency: "", // e.g., 1 = USD
  //       amount: "", // e.g., 120
  //       freqType: "", // e.g., 1 = Hourly
  //       employmentType: "", // e.g., 1 = 1099
  //     },
  //     payRate: {
  //       currency: "",
  //       amount: { min: "", max: "" },
  //       freqType: "",
  //       employmentType: "",
  //     },
  //   },
  // };
  const documentOptions = [
    { label: "Driving License", value: 1 },
    { label: "EML File", value: 2 },
    { label: "Passport", value: 3 },
    { label: "Resume", value: 4 },
    { label: "SSN", value: 5 },
    { label: "Transcripts", value: 6 },
  ];
  const loadJobPost = async (id) => {
    try {
      setIsLoading(true);
      const params = {
        coll: "JobPosting",
        fil: { uiid: { type: "NONE", value: id } },
        extret: "uiid firstName lastName role",
        extincl: "uiid name",
        ref: "Job"
      };
      const response = await fetchJobPost(params);

      if (response?.data) {
        const job = response?.data?.data;
        setJobData(job);
        setJobDescription(job?.orgInform?.jobDescription || "");
        // showToast("Job post loaded successfully!", "success");
      } else {
        showToast("No job found with this ID", "error");
      }
    } catch (err) {
      console.error("Failed to fetch job post:", err);
      showToast("Failed to fetch job post", "error");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (jobpostId) {
      loadJobPost(jobpostId);
    }
  }, [jobpostId]);
  useEffect(() => {
    dispatch(getRaSettingsStart({ coll: "Setting" }));
  }, [dispatch]);
 const initialFormData = {
  jobCode: jobData?.jobInfo?.jobCode || jobCode || "",
  jobTitle: jobData?.jobId?.title || data?.title || "",
  jobStartDate: jobData?.jobInfo?.jobDates?.start || "",
  jobEndDate: jobData?.jobInfo?.jobDates?.end || "",
  remoteJob: jobData?.jobInfo?.remote?.toString() || "",

  payments: {
    billRate: {
      currency: jobData?.jobInfo?.payments?.billRate?.currency || "",
      amount: jobData?.jobInfo?.payments?.billRate?.amount || "",
      freqType: jobData?.jobInfo?.payments?.billRate?.freqType || "",
      employmentType:
        jobData?.jobInfo?.payments?.billRate?.employmentType || "",
    },
    payRate: {
      currency: jobData?.jobInfo?.payments?.payRate?.currency || "",
      amount: {
        min: jobData?.jobInfo?.payments?.payRate?.amount?.min || "",
        max: jobData?.jobInfo?.payments?.payRate?.amount?.max || "",
      },
      freqType: jobData?.jobInfo?.payments?.payRate?.freqType || "",
      employmentType:
        jobData?.jobInfo?.payments?.payRate?.employmentType || "",
    },
  },

  expensePaid: jobData?.jobInfo?.expensesPaid || false,
  country: jobData?.jobInfo?.location?.country || data?.location?.country || "",
  state: jobData?.jobInfo?.location?.state || data?.location?.state || "",
  location: jobData?.jobInfo?.location?.city || data?.location?.city || "",
  zipcode: jobData?.jobInfo?.location?.zipCode || data?.location?.zipCode || "",
  radius: jobData?.aiRecruiter?.radius || 50,
  jobType: jobData?.jobInfo?.type || "",
  requiredHourWeek: jobData?.jobInfo?.reqHourWeek || "",
  client: jobData?.jobId?.companyId?.name || data?.companyId?.name || "",
  endClient: jobData?.jobInfo?.endClient || "",
  clientJobId: jobData?.jobInfo?.clientJobId || "",
  // requiredDocuments: (jobData?.jobInfo?.documents || []).join(", "),
  requiredDocuments:
    jobData.jobInfo?.documents?.map((docValue) => {
      const matched = documentOptions.find((opt) => opt.value === docValue);
      return matched || { label: docValue, value: docValue };
    }) || [],
  turnOutTime: jobData?.jobInfo?.turnoutTime?.value || "",
  turnOutTimeSelect: jobData?.jobInfo?.turnoutTime?.type || "",
  priority: jobData?.jobInfo?.priority || "",
  duration: jobData?.jobInfo?.duration || "",
  areaCode: jobData?.jobInfo?.areaCode || "",
  workAuthorization: (jobData?.jobInfo?.workAuth || []).join(", "),
  clearance: jobData?.jobInfo?.clearance ? "Yes" : "No",
  address: jobData?.jobInfo?.address || "",

    // Skills
    industry: jobData?.skills?.industry || data?.companyId?.industry || "",
    experienceMin: jobData?.skills?.experience?.min || "",
    experienceMax: jobData?.skills?.experience?.max || "",
    primarySkills: (jobData?.skills?.primarySkills || []).join(", "),
    preferredSkills: (jobData?.skills?.preferredSkills || []).join(", "),
    languages: (jobData?.skills?.languages || []).join(", "),
    comments: jobData?.orgInform?.comment || "",

  // Org info
  noOfPosition: jobData?.orgInform?.noOfPosition || "",
  taxTerms: (jobData?.orgInform?.taxTerm || []).join(", "),

  assignedTo:
    jobData?.assignedTo
      ? {
          value: jobData.assignedTo?.uiid,
          label: `${jobData.assignedTo?.firstName}`,
        }
      : "",

  // notifyTo:
  //   jobData?.notifyTo?.map((n) => ({
  //     value: n.uiid,
  //     label: n.firstName,
  //   })) || [],
  notifyTo:
  (jobData?.notifyTo
    ?.filter((n) => n && n.uiid) 
    .map((n) => ({
      value: n.uiid,
      label: n.firstName || "",
    }))) || [],

  };
  const allowOnlyPositiveNumber = (value) => {
    if (value === "" || value === null) return "";

    // Remove invalid chars (e, +, -, etc.)
    const cleaned = value.toString().replace(/[^0-9.]/g, "");

    // Prevent multiple dots
    const parts = cleaned.split(".");
    if (parts.length > 2) return parts[0] + "." + parts[1];

    return cleaned;
  };

  const normalizeToValueArray = (docs) => {
    if (!Array.isArray(docs)) return [];
    return docs.map((d) => (typeof d === "object" ? d.value : d));
  };

  function GenerateJobString(storeData, job) {
    // Remove spaces, truncate the company name to the first 2 characters, and convert to uppercase
    const companyNamePart =
      job?.companyName?.replace(/\s+/g, "").substring(0, 2).toUpperCase() || "";
    const BDMNamePart =
      storeData?.userSudoFirstName
        .replace(/\s+/g, "")
        .substring(0, 2)
        .toUpperCase() || "";
    // Get the current date in the format 'DD-MM-YY'
    const currentDate = new Date();
    const day = String(currentDate.getDate()).padStart(2, "0");
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const year = String(currentDate.getFullYear()).substring(2); // Get the last two digits of the year
    const formattedDate = `${day}${month}${year}`;
    // Get the current timestamp
    const timestamp = Date.now();
    // Combine parts into the desired format with no spaces
    return `${BDMNamePart}${companyNamePart}-${formattedDate}-${timestamp}`;
  }
  const extractUiid = (str) => {
    if (!str || typeof str !== "string") return null;

    const parts = str.split("-");
    const last = parts[parts.length - 1];

    const num = Number(last);
    return isNaN(num) ? null : num;
  };

  const fetchRecruiters = async () => {
    const count = await userRefCount({
      fil: JSON.stringify({
        "role.type": { type: "IN", value: [1, 3, 4] },
        status: { type: "NONE", value: 1 },
      }),
    });
    const recruiterCount = count?.data?.data || 0;
    try {
      const res = await fetchAllRecruitersAndBDMUsers({
        orgId,
        lim: recruiterCount,
        ret: "uiid firstName lastName userType botAssignedTo",
      });
      if (res?.data?.data) {
        const loggedInUiid = user?.data?.uiid;
        const isAdmin = user?.data?.role?.type === 1;

        let filteredRecruiters = res.data.data;
        if (!isAdmin) {
          filteredRecruiters = res.data.data.filter((r) => {
            if (r.userType !== 2) return true;
            const assignedTo = r.botAssignedTo || [];
            const assignedUiids = assignedTo.map(bot => {
              if (typeof bot === "object" && bot !== null) {
                return String(bot.uiid || bot.value);
              }
              return String(bot);
            });
            return assignedUiids.includes(String(loggedInUiid));
          });
        }

        const recruiterList = filteredRecruiters.map((r) => {
          const first = r.firstName || "";
          const last = r.lastName || "";
          const fullName = `${first} ${last}`.trim(); // Removes undefined
          const userType = r.userType || 1

          return {
            label: fullName,
            value: `${fullName}-${r.uiid}`, // Consistent format
            userType
          };
        });

        setAllRecruiters(recruiterList);
      }
    } catch (error) {
      console.error("Failed to fetch recruiters", error);
    }
  };  

  useEffect(() => { fetchRecruiters() },[])
  const { formData, errors, handleChange, validateAllFields, setFormData, setErrors} =
    useFormHandler(initialFormData, {
      jobCode: { type: "text", required: true },
      // zipcode: { type: "number", required: true },
    });
  ///////////////////////////////
  const handleNotifyToChange = async (newValue, isConfirmed = false) => {
    setLoading(true);
    try {
      const normalizedRecruiters = newValue || [];
      const uiidList = normalizedRecruiters
        .map((r) => extractUiid(r))
        .filter((id) => id !== null);

      const allMap = {};
      allRecruiters.forEach(opt => {
        const id = extractUiid(opt.value);
        if (id) allMap[id] = opt;
      });

      const totalBots = uiidList.filter(id => allMap[id] && allMap[id].userType == 2);
      if (totalBots.length > 1) {
        showToast("A job can be assigned to only one bot user.", "error");
        handleChange("notifyTo", [...(formData.notifyTo || [])]);
        return;
      }

      const getNumericUiid = (val) => {
        if (typeof val === "number") return val;
        if (typeof val === "string") {
          const extracted = extractUiid(val);
          if (extracted !== null) return extracted;
          if (!isNaN(Number(val))) return Number(val);
        }
        return null;
      };

      const previousUiids = (formData.notifyTo || []).map(r => getNumericUiid(r)).filter(id => id !== null);
      const freshlyAddedBots = normalizedRecruiters.filter(r => {
        const id = getNumericUiid(r);
        if (id !== null && previousUiids.includes(id)) return false;
        return r.userType == 2 || (allMap[id] && allMap[id].userType == 2);
      });

      if (freshlyAddedBots.length === 1 && !isConfirmed) {
        const botUiid = extractUiid(freshlyAddedBots[0]);
        if (!botUiid) {
          handleChange("notifyTo", [...(formData.notifyTo || [])]);
          return;
        }

        let availableCredits = 0;
        try {
          const integrationResponse = await getAllIntegrations({
            coll: "Integration",
            fil: JSON.stringify({ category: { type: "NONE", value: 6 }, type: { type: "NONE", value: 2 } }),
            ret: "uiid"
          });
          const integrationIds = integrationResponse?.data?.data?.map(i => i.uiid) || [];

          if (integrationIds.length > 0) {
            const accessRes = await getAllIntegrationAccess({
              coll: "IntegrationAccess",
              fil: {
                integrationId: { type: "IN", value: integrationIds },
                userId: { type: "NONE", value: botUiid }
              }
            });
            const accessList = accessRes?.data?.data || [];
            availableCredits = accessList.reduce((sum, access) => sum + Number(access?.accessConfig?.credits || 0), 0);
          }
        } catch (e) {
          console.error("Failed to fetch bot credits", e);
          showToast("Failed to fetch bot credits", "error");
          handleChange("notifyTo", [...(formData.notifyTo || [])]);
          return;
        }

        const orgSettings = raSettings?.[0]?.aiCallSettings || {};
        const maxCallsPerJob = maximumCalls ? Number(maximumCalls || 0) : Number(orgSettings.maxCallsPerJob || 0);
        if (availableCredits === 0) {
          showToast("Cannot assign bot: Zero credits available for this bot recruiter.", "error");
          handleChange("notifyTo", [...(formData.notifyTo || [])]);
          return;
        }

        if (availableCredits < maxCallsPerJob) {
          showToast(`Cannot assign bot: Available credits (${availableCredits}) are less than required maxCallsPerJob (${maxCallsPerJob}).`, "error");
          handleChange("notifyTo", [...(formData.notifyTo || [])]);
          return;
        }

        handleChange("notifyTo", [...(formData.notifyTo || [])]);
        setPendingBotAssignment(newValue);
        setBotConfirmModal(true);
        return;
      }

      handleChange("notifyTo", newValue);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Handle country change - reset state and city
  const handleSubmitApplication = async () => {
    const isValid = validateAllFields();
    if (formData.payments.billRate.amount < 0) {
      showToast("Amount must be positive", "error");
      return;
    }

    if (
      formData.payments.payRate.amount.min < 0 ||
      formData.payments.payRate.amount.max < 0
    ) {
      showToast("Pay rate must be positive", "error");
      return;
    }

    if (formData.experienceMin < 0 || formData.experienceMax < 0) {
      showToast("Experience must be positive", "error");
      return;
    }
    const newErrors = {};
    if (!formData?.primarySkills?.length) {
      newErrors.primarySkills = "Primary skills are required";
      showToast("Primary skills are required", "error");
    }
    if (!formData?.radius || isNaN(Number(formData.radius)) || Number(formData.radius) < 10) {
      newErrors.radius = "Please enter a valid radius (minimum 10 miles)";
      showToast("Please enter a valid radius (minimum 10 miles)", "error");
    }
    setErrors(prev => ({ ...prev, ...newErrors }));

    // if (!isValid) return;
    if (!isValid || Object.keys(newErrors).length > 0) return;

    const payload  = {
      coll: "JobPosting",
      // postActions: ["updateToJob"],
      payload: {
        companyId: data?.companyId?.uiid,
        jobId: data?.uiid,
        jobInfo: {
          jobCode: formData.jobCode,
          jobDates: {
            start: formData.jobStartDate,
            end: formData.jobEndDate,
          },
          remote: parseInt(formData.remoteJob),
          expensesPaid: formData.expensePaid || false,
          location: {
            country: formData.country?.value || formData.country || "",
            state: formData.state?.value || formData.state || "",
            city: formData.location?.value || formData.location || "",
            zipCode: Number(formData?.zipcode) || null,
          },
          type: parseInt(formData.jobType),
          reqHourWeek: parseInt(formData.requiredHourWeek),
          endClient: formData.endClient,
          clientJobId: formData.clientJobId,
          // documents: Array.isArray(formData.requiredDocuments)
          //   ? formData.requiredDocuments
          //   : [formData.requiredDocuments],
          documents: normalizeToValueArray(formData.requiredDocuments),
          turnoutTime: {
            value: formData.turnOutTime,
            type: formData.turnOutTimeSelect,
          },
          priority: parseInt(formData.priority),
          duration: parseInt(formData.duration),
          areaCode: formData.areaCode,
          workAuth: Array.isArray(formData.workAuthorization)
            ? formData.workAuthorization
            : [formData.workAuthorization],
          clearance: formData.clearance === "Yes",
          address: formData.address,
          payments: {
            billRate: {
              currency: formData.payments.billRate.currency,
              amount: formData.payments.billRate.amount,
              freqType: formData.payments.billRate.freqType,
              employmentType: formData.payments.billRate.employmentType,
            },
            payRate: {
              currency: formData.payments.payRate.currency,
              amount: {
                min: formData.payments.payRate.amount.min,
                max: formData.payments.payRate.amount.max,
              },
              freqType: formData.payments.payRate.freqType,
              employmentType: formData.payments.payRate.employmentType,
            },
          },
        },
        skills: {
          industry: formData.industry?.value??formData?.industry,
          experience: {
            min: parseInt(formData.experienceMin) || 0,
            max: parseInt(formData.experienceMax) || 0,
          },
          // primarySkills: formData.primarySkills
          //   ? formData.primarySkills.split(",")
          //   : [],
          primarySkills: Array.isArray(formData.primarySkills)
            ? formData.primarySkills
            : [],
          preferredSkills: Array.isArray(formData.preferredSkills)
            ? formData.preferredSkills
            : [],
          languages: Array.isArray(formData.languages)
            ? formData.languages
            : [formData.languages],
        },
        orgInform: {
          noOfPosition: formData.noOfPosition,
          taxTerm: formData.taxTerms,
          // noOfPosition: 1,
          jobDescription: jobDescription,
          comment: formData.comments || "",
        },
        assignedTo: formData.assignedTo?.value,
        // notifyTo: Array.isArray(formData.notifyTo?.value)
        //   ? formData.notifyTo.value
        //   : [formData.notifyTo.value],
        // notifyTo : formData.notifyTo || [],
        notifyTo: (formData.notifyTo || [])
          .map(extractUiid)
          .filter((x) => x !== null),
         statusHistory:[{
                addedBy: user.data.uiid,
                addedOn: new Date(),
                status: 2,
              }],
        addedBy: user.data.uiid,
        aiRecruiter: {
          radius: Number(formData.radius) || 50
        }
      },
    };

    const isAiRecruiter = allRecruiters.find((recruiter) => formData.notifyTo.includes(recruiter.value) && recruiter.userType == 2);
    if(isAiRecruiter){
      payload["payload"]["aiRecruiter"] = {
        isAiRecruiter: true,
        status: 1,
        maximumCalls: Number(maximumCalls),
        radius: Number(formData.radius) || 50
      }
    }
  // try {
  //   const response = await addJobPosting(payload); 
  //   // showToast("Job posted successfully!", "success",2000);
  //   if(response?.data) {
  //     showToast("Job posted successfully!", "success",2000);
  //     // onClose();
  //     onSuccess();
  //   } else {
  //     showToast(response.error || "An error occured", "error", 2000);
  //   }
  // } catch (err) {
  //   console.error(err);
  //   showToast("Failed to post job", "error");
  // }
   try {
    setLoading(true);
    // if (editData?.uiid) {
    if (jobData?.uiid) {
      const editPayload = {
        coll: "JobPosting",
        uiid: jobData?.uiid,
        payload: [
          {
            type: "SET",
            value: {
              _skipFlatten: [
                "skills.primarySkills",
                "skills.preferredSkills",
                "skills.languages",
              ],
              jobId: jobData?.jobId?.uiid || jobData?.jobId,
              companyId: jobData?.companyId?.uiid || jobData?.companyId,
              jobInfo: {
                jobCode: formData.jobCode,
                jobDates: {
                  start: formData.jobStartDate,
                  end: formData.jobEndDate,
                },
                remote: parseInt(formData.remoteJob),
                expensesPaid: formData.expensePaid || false,
                location: {
                  country: formData.country?.value || formData.country || "",
                  state: formData.state?.value || formData.state || "",
                  city: formData.location?.value || formData.location || "",
                  zipCode: Number(formData?.zipcode) || null,
                },
                type: parseInt(formData.jobType),
                reqHourWeek: parseInt(formData.requiredHourWeek),
                endClient: formData.endClient,
                clientJobId: formData.clientJobId,
                // documents: Array.isArray(formData.requiredDocuments)
                //   ? formData.requiredDocuments
                //   : [formData.requiredDocuments],
                documents: normalizeToValueArray(formData.requiredDocuments),
                turnoutTime: {
                  value: formData.turnOutTime,
                  type: formData.turnOutTimeSelect,
                },
                priority: parseInt(formData.priority),
                duration: parseInt(formData.duration),
                areaCode: formData.areaCode,
                workAuth: Array.isArray(formData.workAuthorization)
                  ? formData.workAuthorization
                  : [formData.workAuthorization],
                clearance: formData.clearance === "Yes",
                address: formData.address,
                payments: {
                  billRate: {
                    currency: formData.payments.billRate.currency,
                    amount: formData.payments.billRate.amount,
                    freqType: formData.payments.billRate.freqType,
                    employmentType:
                      formData.payments.billRate.employmentType,
                  },
                  payRate: {
                    currency: formData.payments.payRate.currency,
                    amount: {
                      min: formData.payments.payRate.amount.min,
                      max: formData.payments.payRate.amount.max,
                    },
                    freqType: formData.payments.payRate.freqType,
                    employmentType:
                      formData.payments.payRate.employmentType,
                  },
                },
              },
              skills: {
                industry: formData.industry?.value??formData?.industry,
                experience: {
                  min: parseInt(formData.experienceMin) || 0,
                  max: parseInt(formData.experienceMax) || 0,
                },
                // primarySkills: formData.primarySkills
                //   ? formData.primarySkills.split(",")
                //   : [],
                primarySkills: Array.isArray(formData.primarySkills)
                  ? formData.primarySkills
                  : typeof formData.primarySkills === "string" &&
                      formData.primarySkills.trim() !== ""
                    ? formData.primarySkills.split(",")
                    : [],
                preferredSkills: Array.isArray(formData.preferredSkills)
                  ? formData.preferredSkills
                  : typeof formData.preferredSkills === "string" &&
                      formData.preferredSkills.trim() !== ""
                    ? formData.preferredSkills.split(",")
                    : [],
                languages: Array.isArray(formData.languages)
                  ? formData.languages
                  : [formData.languages],
              },
              orgInform: {
                noOfPosition: formData.noOfPosition,
                taxTerm: formData.taxTerms,
                jobDescription: jobDescription,
                comment: formData.comments || "",
              },
              assignedTo: formData.assignedTo?.value,
              // notifyTo: (formData.notifyTo || []).map((n) => n.value),
              notifyTo: (formData.notifyTo || [])
                .map(extractUiid)
                .filter((x) => x !== null),
              aiRecruiter: {
                radius: Number(formData.radius) || 50
              }
            },
          },
        ],
      };

      if (isAiRecruiter) {
        editPayload.payload[0].value.aiRecruiter = {
          isAiRecruiter: true,
          status: 1,
          maximumCalls: Number(maximumCalls) || 0,
          radius: Number(formData.radius) || 50
        };
      }

      const response = await updateJobPosting(editPayload);
      if (response?.data) {
        showToast("Job Posting updated successfully!", "success", 2000);
        if(onSuccess) onSuccess?.();
      } else {
        showToast(response.error || "An error occurred", "error", 2000);
      }
    } else {
      const response = await addJobPosting(payload);
      if (response?.data) {
        showToast("Job posted successfully!", "success", 2000);
        if(onSuccess) onSuccess?.();
         trackEvent({eventName:"Job_Created",props:{companyName:data?.companyId?.name||data?.companyId?.uiid,jobTitle:data?.title}})
      } else {
        showToast(response.error || "An error occurred", "error", 2000);
      }
    }
  } catch (err) {
    console.error(err);
    showToast("Failed to submit job", "error");
  } finally {
    setLoading(false);
  }
};

  const handleCountryChange = (value) => {
    handleChange("country", value);
    // Reset dependent fields
    handleChange("state", "");
    handleChange("city", "");
  };
  // Handle state change - reset city
  const handleStateChange = (value) => {
    handleChange("state", value);
    // Reset dependent field
    handleChange("city", "");
  };
//   useEffect(() => {
//   if (jobData) {
//     setFormData(initialFormData);
//     setJobDescription(jobData.orgInform?.jobDescription || "");
//   }
// }, [editData]);
  useEffect(() => {
    if (jobData && Object.keys(jobData).length > 0) {
      const updatedFormData = {
        jobCode: jobData?.jobInfo?.jobCode || jobCode || "",
        jobTitle: jobData?.jobId?.title || data?.title || "",
        jobStartDate: jobData?.jobInfo?.jobDates?.start || "",
        jobEndDate: jobData?.jobInfo?.jobDates?.end || "",
        remoteJob: jobData?.jobInfo?.remote?.toString() || "",

        payments: {
          billRate: {
            currency: jobData?.jobInfo?.payments?.billRate?.currency || "",
            amount: jobData?.jobInfo?.payments?.billRate?.amount || "",
            freqType: jobData?.jobInfo?.payments?.billRate?.freqType || "",
            employmentType:
              jobData?.jobInfo?.payments?.billRate?.employmentType || "",
          },
          payRate: {
            currency: jobData?.jobInfo?.payments?.payRate?.currency || "",
            amount: {
              min: jobData?.jobInfo?.payments?.payRate?.amount?.min || "",
              max: jobData?.jobInfo?.payments?.payRate?.amount?.max || "",
            },
            freqType: jobData?.jobInfo?.payments?.payRate?.freqType || "",
            employmentType:
              jobData?.jobInfo?.payments?.payRate?.employmentType || "",
          },
        },

        expensePaid: jobData?.jobInfo?.expensesPaid || false,
        country: jobData?.jobInfo?.location?.country || data?.location?.country || "",
        state: jobData?.jobInfo?.location?.state || data?.location?.state || "",
        location: jobData?.jobInfo?.location?.city || data?.location?.city || "",
        zipcode: jobData?.jobInfo?.location?.zipCode || data?.location?.zipCode || "",
        radius: jobData?.aiRecruiter?.radius || 50,
        jobType: jobData?.jobInfo?.type || "",
        requiredHourWeek: jobData?.jobInfo?.reqHourWeek || "",
        client: jobData?.jobId?.companyId?.name || data?.companyId?.name || companyName || "",
        endClient: jobData?.jobInfo?.endClient || "",
        clientJobId: jobData?.jobInfo?.clientJobId || "",
        // requiredDocuments: (jobData?.jobInfo?.documents || []).join(", "),
        requiredDocuments:
          jobData.jobInfo?.documents.filter(Boolean).map((docValue) => {
            const matched = documentOptions.find((opt) => opt.value === docValue);
            return matched || { label: docValue, value: docValue };
          }) || [],
        turnOutTime: jobData?.jobInfo?.turnoutTime?.value || "",
        turnOutTimeSelect: jobData?.jobInfo?.turnoutTime?.type || "",
        priority: jobData?.jobInfo?.priority || "",
        duration: jobData?.jobInfo?.duration || "",
        areaCode: jobData?.jobInfo?.areaCode || "",
        workAuthorization: (jobData?.jobInfo?.workAuth || []).join(", "),
        clearance: jobData?.jobInfo?.clearance ? "Yes" : "No",
        address: jobData?.jobInfo?.address || "",

        // Skills
        industry: jobData?.skills?.industry || "",
        experienceMin: jobData?.skills?.experience?.min || "",
        experienceMax: jobData?.skills?.experience?.max || "",
        // primarySkills: (jobData?.skills?.primarySkills || []).join(", "),
        primarySkills: (jobData?.skills?.primarySkills || []),
        preferredSkills: (jobData?.skills?.preferredSkills || []),
        // languages: (jobData?.skills?.languages || []).join(", "),
        languages: Array.isArray(jobData?.skills?.languages)
          ? jobData.skills.languages.filter(lang => lang && lang.trim() !== "")
          : [],
        comments: jobData?.orgInform?.comment || "",

        // Org info
        noOfPosition: jobData?.orgInform?.noOfPosition || "",
        taxTerms: (jobData?.orgInform?.taxTerm || []).join(", "),

        assignedTo:
          jobData?.assignedTo
            ? {
              value: jobData.assignedTo?.uiid,
              label: `${jobData.assignedTo?.firstName}`,
            }
            : "",

        // notifyTo:
        //   jobData?.notifyTo?.map((n) => ({
        //     value: n.uiid,
        //     label: n.firstName,
        //   })) || [],
        // notifyTo:
        //   (jobData?.notifyTo
        //     ?.filter((n) => n && n.uiid)
        //     .map((n) => ({
        //       value: n.uiid,
        //       label: n.firstName || "",
        //     }))) || [],
        notifyTo:
  Array.isArray(jobData?.notifyTo)
    ? jobData.notifyTo
        .filter((n) => n && n.uiid)
        .map((n) => {
          const fullName = [n.firstName, n.lastName]   // supports lastname if exists
            .filter(Boolean)
            .join(" ")
            .trim();

          return {
            label: fullName,                       // "mahi" or "Alice joghn"
            value: `${fullName}-${n.uiid}`,        // "mahi-13" or "Alice joghn-83"
          };
        })
    : [],

      };
      setFormData(updatedFormData);
      setJobDescription(jobData.orgInform?.jobDescription || jobData?.jobId?.description || "");
      if (jobData?.aiRecruiter?.maximumCalls) {
        setMaximumCalls(jobData.aiRecruiter.maximumCalls);
      }
    }
  }, [jobData]);

  ///////////////////////////////

  return (
    <div>
      <h6>Job Details</h6>
      <div className="w-20 h-0.5 bg-primary"></div>
      <div className=" grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-4 gap-y-5 mt-5">
        <FormFieldSet
          title="Job Code"
          placeholder="Job Code"
          value={formData.jobCode}
          onChange={(value) => handleChange("jobCode", value)}
          error={errors.jobCode}
          shadow={true}
          disabled={true}
        />

        <FormFieldSet
          title="Job Title"
          placeholder="Job Title"
          value={formData.jobTitle}
          onChange={(value) => handleChange("jobTitle", value)}
          error={errors.jobTitle}
          shadow={true}
        />
        <FormFieldSet
          title="Job Start Date"
          placeholder="Job Start Date"
          type="datepicker"
          minDate={yesterday}
          value={formData.jobStartDate}
          onChange={(value) => handleChange("jobStartDate", value)}
          error={errors.jobStartDate}
          shadow={true}
        />

        <FormFieldSet
          title="Job End Date"
          placeholder="Job End Date"
          type="datepicker"
          minDate={yesterday}
          value={formData.jobEndDate}
          onChange={(value) => handleChange("jobEndDate", value)}
          error={errors.jobEndDate}
          shadow={true}
        />

        <FormFieldSet
          name="remoteJob"
          title="Remote Job"
          type="radio"
          options={[
            { label: "Yes", value: 1 },
            { label: "No", value: 2 },
            { label: "Hybrid", value: 3 },
          ]}
          value={formData.remoteJob}
          onChange={(e) => handleChange("remoteJob", e.target.value)}
          error={errors.remoteJob}
        />

        <div className="col-span-2 lg:col-span-3 xl:col-span-4">
          <div className="text-[12px] font-medium mb-0.5 min-h-[18px]">
            Client Bill Rate / Salary
          </div>
          <div className="grid lg:grid-cols-3 grid-cols-2 xl:grid-cols-4  gap-4">
            <FormFieldSet
              noTitle
              type="select"
              placeholder="Currency"
              options={[
                { label: "USD", value: 1 },
                { label: "INR", value: 2 },
                { label: "CAN", value: 3 },
              ]}
              value={formData.payments.billRate.currency}
              onChange={(value) =>
                handleChange("payments", {
                  ...formData.payments,
                  billRate: {
                    ...formData.payments.billRate,
                    currency: value,
                  },
                })
              }
              shadow={true}
            />
            {/* <FormFieldSet noTitle placeholder="" /> */}
            <FormFieldSet
              noTitle
              type="number"
              placeholder="Amount"
              value={formData.payments.billRate.amount}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onChange={(value) => {
                const valid = allowOnlyPositiveNumber(value);
                handleChange("payments", {
                  ...formData.payments,
                  billRate: {
                    ...formData.payments.billRate,
                    amount: valid,
                  },
                });
              }}
              shadow={true}
            />
            <FormFieldSet
              noTitle
              type="select"
              options={[
                { label: "Hourly", value: 1 },
                { label: "Daily", value: 2 },
                { label: "Weekly", value: 3 },
                { label: "Bi-Weekly", value: 4 },
                { label: "Monthly", value: 5 },
                { label: "Yearly", value: 6 },
              ]}
              placeholder="Select"
              value={formData.payments.billRate.freqType}
              onChange={(value) =>
                handleChange("payments", {
                  ...formData.payments,
                  billRate: {
                    ...formData.payments.billRate,
                    freqType: value,
                  },
                })
              }
              shadow={true}
              showSearch
            />
            <FormFieldSet
              noTitle
              type="select"
              placeholder="Select"
              options={[
                { label: "1099", value: 1 },
                { label: "C2C", value: 2 },
                { label: "C2C", value: 3 },
                { label: "Full Time", value: 4 },
                { label: "In-cop", value: 5 },
                { label: "Intern", value: 6 },
                { label: "Other", value: 7 },
                { label: "Part Time", value: 8 },
                { label: "W-2", value: 9 },
              ]}
              value={formData.payments.billRate.employmentType}
              onChange={(value) =>
                handleChange("payments", {
                  ...formData.payments,
                  billRate: {
                    ...formData.payments.billRate,
                    employmentType: value,
                  },
                })
              }
              shadow={true}
              showSearch
            />
          </div>
        </div>
        <div className="col-span-2 lg:col-span-3 xl:col-span-4">
          <div className="text-[12px] font-medium mb-0.5 min-h-[18px]">
            Pay Rate / Salary
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            <FormFieldSet
              noTitle
              type="select"
              placeholder="Currency"
              options={[
                { label: "USD", value: 1 },
                { label: "INR", value: 2 },
                { label: "CAN", value: 3 },
              ]}
              value={formData.payments.payRate.currency}
              onChange={(value) =>
                handleChange("payments", {
                  ...formData.payments,
                  payRate: { ...formData.payments.payRate, currency: value },
                })
              }
              shadow={true}
            />
            <FormFieldSet
              noTitle
              type="number"
              placeholder="min"
              value={formData.payments.payRate.amount.min}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onChange={(value) => {
                const valid = allowOnlyPositiveNumber(value);
                handleChange("payments", {
                  ...formData.payments,
                  payRate: {
                    ...formData.payments.payRate,
                    amount: {
                      ...formData.payments.payRate.amount,
                      min: valid,
                    },
                  },
                });
              }}
              shadow={true}
            />
            {/* <FormFieldSet noTitle type="select" placeholder="Select" /> */}
            <FormFieldSet
              noTitle
              type="number"
              placeholder="max"
              value={formData.payments.payRate.amount.max}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onChange={(value) => {
                const valid = allowOnlyPositiveNumber(value);
                handleChange("payments", {
                  ...formData.payments,
                  payRate: {
                    ...formData.payments.payRate,
                    amount: {
                      ...formData.payments.payRate.amount,
                      max: valid,
                    },
                  },
                });
              }}
              shadow={true}
            />
            <FormFieldSet
              noTitle
              type="select"
              placeholder="Select Frequency"
              options={[
                { label: "Hourly", value: 1 },
                { label: "Daily", value: 2 },
                { label: "Weekly", value: 3 },
                { label: "Bi-Weekly", value: 4 },
                { label: "Monthly", value: 5 },
                { label: "Yearly", value: 6 },
              ]}
              value={formData.payments.payRate.freqType}
              onChange={(value) =>
                handleChange("payments", {
                  ...formData.payments,
                  payRate: { ...formData.payments.payRate, freqType: value },
                })
              }
              shadow={true}
              showSearch
            />
            <FormFieldSet
              noTitle
              type="select"
              placeholder="Select"
              options={[
                { label: "1099", value: 1 },
                { label: "C2C", value: 2 },
                { label: "C2C", value: 3 },
                { label: "Full Time", value: 4 },
                { label: "In-cop", value: 5 },
                { label: "Intern", value: 6 },
                { label: "Other", value: 7 },
                { label: "Part Time", value: 8 },
                { label: "W-2", value: 9 },
              ]}
              value={formData.payments.payRate.employmentType}
              onChange={(value) =>
                handleChange("payments", {
                  ...formData.payments,
                  payRate: {
                    ...formData.payments.payRate,
                    employmentType: value,
                  },
                })
              }
              shadow={true}
              showSearch
            />
          </div>
        </div>

        <FormFieldSet
          title="Expenses Paid"
          label="Added"
          labelPosition="after"
          type="toggle"
          isChecked={formData.expensePaid}
          onChange={() => handleChange("expensePaid", !formData.expensePaid)}
          error={errors.expensePaid}
        />

        <FormFieldSet
          type="countriesUsAndCanada"
          title={"Country"}
          placeholder="Select Country"
          value={formData.country}
          onChange={handleCountryChange} // Use the custom handler
          error={errors.country}
          required
          shadow={true}
        />

        <FormFieldSet
          showSearch
          type="states"
          title={"State"}
          keyname={"states"}
          placeholder="Select State"
          value={formData.state}
          onChange={handleStateChange} // Use the custom handler
          error={errors.state}
          required
          parentValue={{ country: formData.country.value }}
          disabled={!formData.country}
          shadow={true}
        />

        <FormFieldSet
          type="cities"
          showSearch
          keyname={"cities"}
          title={"Location"}
          placeholder="Location"
          value={formData.location}
          onChange={(value) => handleChange("location", value)}
          error={errors.location}
          required
          parentValue={{
            country: formData.country.value,
            state: formData.state.value,
          }}
          // parentId={countryId}
          disabled={!formData.state}
          shadow={true}
        />

        <FormFieldSet
          type="number"
          title="Zipcode"
          placeholder="Enter Zipcode"
          value={formData.zipcode}
          onKeyDown={(e) => {
            if (["e", "E", "+", "-"].includes(e.key)) {
              e.preventDefault();
            }
          }}
          onChange={(value) => handleChange("zipcode", allowOnlyPositiveNumber(value))}
          error={errors.zipcode}
          shadow={true}
        />

        <FormFieldSet
          type="number"
          title="Radius"
          placeholder="Enter Radius"
          value={formData.radius}
          onKeyDown={(e) => {
            if (["e", "E", "+", "-"].includes(e.key)) {
              e.preventDefault();
            }
          }}
          onChange={(value) => handleChange("radius", allowOnlyPositiveNumber(value))}
          error={errors.radius}
          shadow={true}
        />

        <FormFieldSet
          title="Job Type"
          placeholder="Select"
          type="select"
          options={[
            { label: "Full Time", value: 1 },
            { label: "Contract", value: 2 },
            { label: "Part Time", value: 3 },
          ]}
          value={formData.jobType}
          onChange={(value) => handleChange("jobType", value)}
          error={errors.jobType}
          shadow={true}
        />

        <FormFieldSet
          title="Required Hour/Week"
          placeholder="Required Hour/Week"
          value={formData.requiredHourWeek}
          onChange={(value) => handleChange("requiredHourWeek", value)}
          error={errors.requiredHourWeek}
          shadow={true}
        />

        <FormFieldSet
          title="Client"
          placeholder="Client"
          value={formData.client}
          onChange={(value) => handleChange("client", value)}
          error={errors.client}
          shadow={true}
        />

        <FormFieldSet
          title="End Client"
          placeholder="End Client"
          value={formData.endClient}
          onChange={(value) => handleChange("endClient", value)}
          error={errors.endClient}
          shadow={true}
        />

        <FormFieldSet
          title="Client Job ID"
          placeholder="Client Job ID"
          value={formData.clientJobId}
          onChange={(value) => handleChange("clientJobId", value)}
          error={errors.clientJobId}
          shadow={true}
        />

        <FormFieldSet
          title="Required Documents"
          placeholder="Select"
          type="select"
          options={documentOptions}
          value={formData.requiredDocuments}
          onChange={(value) =>{
             handleChange("requiredDocuments", value)
          }}
          error={errors.requiredDocuments}
          shadow={true}
          multiple
          showSearch
        />

        <div>
          <div className="text-[12px] font-medium mb-0.5 min-h-[18px]">
            Turnout Time
          </div>
          <div className="grid grid-cols-2 gap-4">
            <FormFieldSet
              noTitle
              placeholder=""
              value={formData.turnOutTime}
              onChange={(value) => handleChange("turnOutTime", value)}
              error={errors.turnOutTime}
              shadow={true}
            />

            <FormFieldSet
              noTitle
              type="select"
              placeholder="."
              options={[
                { label: "In Hours", value: 1 },
                { label: "In Days", value: 2 },
              ]}
              value={formData.turnOutTimeSelect}
              onChange={(value) => handleChange("turnOutTimeSelect", value)}
              error={errors.turnOutTimeSelect}
              shadow={true}
            />
          </div>
        </div>
        <FormFieldSet
          title="Priority"
          placeholder="Select"
          type="select"
          options={[
            { label: "Critical", value: 1 },
            { label: "High", value: 2 },
            { label: "Low", value: 3 },
            { label: "Medium", value: 4 },
          ]}
          value={formData.priority}
          onChange={(value) => handleChange("priority", value)}
          error={errors.priority}
          shadow={true}
        />

        <FormFieldSet
          title="Duration"
          placeholder="Select"
          type="select"
          options={[
            { label: "1 Day", value: 1 },
            { label: "2 Days", value: 2 },
            { label: "3 Days", value: 3 },
          ]}
          value={formData.duration}
          onChange={(value) => handleChange("duration", value)}
          error={errors.duration}
          shadow={true}
        />

        <FormFieldSet
          title="Area Code"
          placeholder="Area Code"
          value={formData.areaCode}
          onChange={(value) => handleChange("areaCode", value)}
          error={errors.areaCode}
          shadow={true}
        />

        <FormFieldSet
          title="Work Authorization"
          placeholder="Select"
          type="select"
          options={[
            { label: "B1", value: "B1" },
            { label: "Bangladesh Authorized", value: "Bangladesh Authorized" },
            { label: "Brazil Authorized", value: "Brazil Authorized" },
            {
              label: "Can work for any employer",
              value: "Can work for any employer",
            },
            { label: "Canada Authorized", value: "Canada Authorized" },
            { label: "Canadian Citizen", value: "Canadian Citizen" },
            { label: "Canadian Citizenship", value: "Canadian Citizenship" },
            { label: "China Authorized", value: "China Authorized" },
            { label: "Citizen", value: "Citizen" },
            { label: "Colombia Authorized", value: "Colombia Authorized" },
            { label: "Current Employer Only", value: "Current Employer Only" },
            {
              label: "Employment Auth Document",
              value: "Employment Auth Document",
            },
            {
              label: "Employment Auth. Document",
              value: "Employment Auth. Document",
            },
            {
              label: "Employment Authorization Document",
              value: "Employment Authorization Document",
            },
            { label: "EU Eligible", value: "EU Eligible" },
            { label: "GC", value: "GC" },
            { label: "GC-EAD", value: "GC-EAD" },
            { label: "Germany Authorized", value: "Germany Authorized" },
            { label: "Green Card", value: "Green Card" },
            { label: "Green Card Holder", value: "Green Card Holder" },
            { label: "H1-B", value: "H1-B" },
            { label: "H4 EAD", value: "H4 EAD" },
            { label: "Have H1", value: "Have H1" },
            { label: "Have H1 Visa", value: "Have H1 Visa" },
            { label: "India Authorized", value: "India Authorized" },
            { label: "Ireland Authorized", value: "Ireland Authorized" },
            { label: "Italy Authorized", value: "Italy Authorized" },
            { label: "Kuwait Authorized", value: "Kuwait Authorized" },
            { label: "L1-A", value: "L1-A" },
            { label: "L1-B", value: "L1-B" },
            { label: "L2-EAD", value: "L2-EAD" },
            { label: "Luxembourg Authorized", value: "Luxembourg Authorized" },
            { label: "Macedonia Authorized", value: "Macedonia Authorized" },
            { label: "Mexico Authorized", value: "Mexico Authorized" },
            { label: "Need H1", value: "Need H1" },
            { label: "Need H1 Visa", value: "Need H1 Visa" },
            { label: "Need H1 Visa Sponsor", value: "Need H1 Visa Sponsor" },
            { label: "Not specified", value: "Not specified" },
            { label: "OPT-EAD", value: "OPT-EAD" },
            { label: "Pakistan Authorized", value: "Pakistan Authorized" },
            { label: "Poland Authorized", value: "Poland Authorized" },
            {
              label: "Russian Federation Authorized",
              value: "Russian Federation Authorized",
            },
            {
              label: "South Africa Authorized",
              value: "South Africa Authorized",
            },
            { label: "Sponsorship Required", value: "Sponsorship Required" },
            { label: "TN Permit Holder", value: "TN Permit Holder" },
            { label: "TN Visa", value: "TN Visa" },
            { label: "Turkey Authorized", value: "Turkey Authorized" },
            { label: "Ukraine Authorized", value: "Ukraine Authorized" },
            {
              label: "United Arab Emirates Authorized",
              value: "United Arab Emirates Authorized",
            },
            {
              label: "United Kingdom Authorized",
              value: "United Kingdom Authorized",
            },
            { label: "US Authorized", value: "US Authorized" },
            { label: "US Citizen", value: "US Citizen" },
            { label: "US Citizenship", value: "US Citizenship" },
            { label: "CTCT", value: "CTCT" },
            { label: "CTEM", value: "CTEM" },
            { label: "EAEA", value: "EAEA" },
          ]}
          value={formData.workAuthorization}
          onChange={(value) => handleChange("workAuthorization", value)}
          error={errors.workAuthorization}
          shadow={true}
          showSearch
        />

        <FormFieldSet
          name="clearance"
          title="Clearance"
          type="radio"
          options={[
            { label: "Yes", value: "Yes" },
            { label: "No", value: "No" },
          ]}
          value={formData.clearance}
          onChange={(e) => handleChange("clearance", e.target.value)}
          error={errors.clearance}
        />
        <div className="col-span-2">
          <FormFieldSet
            title="Address"
            placeholder="Address"
            type="textArea"
            rows={3}
            value={formData.address}
            onChange={(value) => handleChange("address", value)}
            error={errors.address}
            shadow={true}
          />
        </div>
      </div>

      <div className="flex flex-col gap-4 mt-4"></div>
      <div>
        <h6>Skills</h6>
        <div className="xl:mr-20 2xl:mr-40 grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-4 gap-y-5">
          {/* <FormFieldSet
            title="Industry"
            placeholder="Select"
            type="select"
            options={[
              { label: "Accounting - Finance", value: "Accounting - Finance" },
              { label: "Advertising", value: "Advertising" },
              { label: "Agriculture", value: "Agriculture" },
              { label: "Airline - Aviation", value: "Airline - Aviation" },
              {
                label: "Architecture - Building",
                value: "Architecture - Building",
              },
              {
                label: "Art - Photography - Journalism",
                value: "Art - Photography - Journalism",
              },
              {
                label: "Automotive - Motor Vehicles - Parts",
                value: "Automotive - Motor Vehicles - Parts",
              },
              {
                label: "Banking - Financial Services",
                value: "Banking - Financial Services",
              },
              { label: "Biotechnology", value: "Biotechnology" },
              {
                label: "Broadcasting - Radio - TV",
                value: "Broadcasting - Radio - TV",
              },
              { label: "Building Materials", value: "Building Materials" },
              { label: "Chemical", value: "Chemical" },
              { label: "Computer Hardware", value: "Computer Hardware" },
              { label: "Computer Software", value: "Computer Software" },
              { label: "Construction", value: "Construction" },
              { label: "Consulting", value: "Consulting" },
              { label: "Consumer Products", value: "Consumer Products" },
              {
                label: "Credit - Loan - Collections",
                value: "Credit - Loan - Collections",
              },
              { label: "Defense - Aerospace", value: "Defense - Aerospace" },
              {
                label: "Education - Teaching - Administration",
                value: "Education - Teaching - Administration",
              },
              { label: "Electronics", value: "Electronics" },
              {
                label: "Employment - Recruiting - Staffing",
                value: "Employment - Recruiting - Staffing",
              },
              {
                label: "Energy - Utilities - Gas - Electric",
                value: "Energy - Utilities - Gas - Electric",
              },
              { label: "Entertainment", value: "Entertainment" },
              { label: "Environmental", value: "Environmental" },
              { label: "Exercise - Fitness", value: "Exercise - Fitness" },
              {
                label: "Fashion - Apparel - Textile",
                value: "Fashion - Apparel - Textile",
              },
              { label: "Food", value: "Food" },
              { label: "Funeral - Cemetery", value: "Funeral - Cemetery" },
              {
                label: "Government - Civil Service",
                value: "Government - Civil Service",
              },
              {
                label: "Healthcare - Health Services",
                value: "Healthcare - Health Services",
              },
              { label: "Homebuilding", value: "Homebuilding" },
              { label: "Hospitality", value: "Hospitality" },
              { label: "Hotel - Resort", value: "Hotel - Resort" },
              { label: "HVAC", value: "HVAC" },
              { label: "Import - Export", value: "Import - Export" },
              { label: "Industrial", value: "Industrial" },
              { label: "Insurance", value: "Insurance" },
              { label: "Internet - ECommerce", value: "Internet - ECommerce" },
              { label: "Landscaping", value: "Landscaping" },
              { label: "Law Enforcement", value: "Law Enforcement" },
              { label: "Legal", value: "Legal" },
              { label: "Library Science", value: "Library Science" },
              { label: "Managed Care", value: "Managed Care" },
              { label: "Manufacturing", value: "Manufacturing" },
              { label: "Medical Equipment", value: "Medical Equipment" },
              { label: "Merchandising", value: "Merchandising" },
              { label: "Military", value: "Military" },
              { label: "Mortgage", value: "Mortgage" },
              { label: "Newspaper", value: "Newspaper" },
              {
                label: "Not for Profit - Charitable",
                value: "Not for Profit - Charitable",
              },
              {
                label: "Office Supplies - Equipment",
                value: "Office Supplies - Equipment",
              },
              {
                label: "Oil Refining - Petroleum - Drilling",
                value: "Oil Refining - Petroleum - Drilling",
              },
              {
                label: "Other Great Industries",
                value: "Other Great Industries",
              },
              { label: "Packaging", value: "Packaging" },
              { label: "Pharmaceutical", value: "Pharmaceutical" },
              {
                label: "Printing - Publishing",
                value: "Printing - Publishing",
              },
              { label: "Public Relations", value: "Public Relations" },
              {
                label: "Real Estate - Property Mgt",
                value: "Real Estate - Property Mgt",
              },
              { label: "Recreation", value: "Recreation" },
              { label: "Restaurant", value: "Restaurant" },
              { label: "Retail", value: "Retail" },
              { label: "Sales - Marketing", value: "Sales - Marketing" },
              { label: "Securities", value: "Securities" },
              { label: "Security", value: "Security" },
              { label: "Semiconductor", value: "Semiconductor" },
              { label: "Social Services", value: "Social Services" },
              { label: "Telecommunications", value: "Telecommunications" },
              { label: "Training", value: "Training" },
              { label: "Transportation", value: "Transportation" },
              { label: "Travel", value: "Travel" },
              { label: "Wireless", value: "Wireless" },
            ]}
            value={formData.industry}
            onChange={(value) => handleChange("industry", value)}
            error={errors.industry}
            shadow={true}
            showSearch
          /> */}
          <FormFieldSet
                      type="industry"
                      title="Select Industry"
                      placeholder="Select Industry"
                      options={[]}
                      showButton
                      showSearch
                      value={formData.industry || ""}
                      onChange={(value) => handleChange("industry", value)}
                    />
          <div className="flex flex-col">
            <div className="text-[12px] font-medium mb-0.5 min-h-[18px]">
              Experience
            </div>
            <div className="grid grid-cols-2 gap-4">
              <FormFieldSet
                noTitle
                type="number"
                placeholder="Min"
                value={formData.experienceMin}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(value) => {
                  handleChange("experienceMin", allowOnlyPositiveNumber(value));
                }}
                error={errors.experienceMin}
                shadow={true}
              />
              <FormFieldSet
                noTitle
                type="number"
                placeholder="Max"
                value={formData.experienceMax}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(value) => {
                  handleChange("experienceMax", allowOnlyPositiveNumber(value));
                }}
                error={errors.experienceMax}
                shadow={true}
              />
            </div>
          </div>
          <FormFieldSet
            type="tags"
            title="Primary Skills"
            placeholder="Add Primary Skills and Press Enter"
            value={formData.primarySkills}
            onChange={(value) => handleChange("primarySkills", value)}
            error={errors.primarySkills}
            shadow={true}
            maxCount={50}
            required="true"
          />
          <FormFieldSet
            type="tags"
            title="Preferred Skills"
            placeholder="Add Preferred Skills and Press Enter"
            value={formData.preferredSkills}
            onChange={(value) => handleChange("preferredSkills", value)}
            error={errors.preferredSkills}
            shadow={true}
            maxCount={50}
          />
          <FormFieldSet
            title="Languages"
            placeholder="Select"
            type="select"
            options={[
              { label: "Arabic", value: "Arabic" },
              { label: "Chinese", value: "Chinese" },
              { label: "English", value: "English" },
              { label: "French", value: "French" },
              { label: "German", value: "German" },
              { label: "Hindi", value: "Hindi" },
              { label: "Italian", value: "Italian" },
              { label: "Japanese", value: "Japanese" },
              { label: "Korean", value: "Korean" },
              { label: "Mandarin", value: "Mandarin" },
              { label: "Persian", value: "Persian" },
              { label: "Portuguese", value: "Portuguese" },
              { label: "Russain", value: "Russain" },
              { label: "Spanish", value: "Spanish" },
              { label: "Swedish", value: "Swedish" },
              { label: "Trukish", value: "Trukish" },
              { label: "Vietnamese", value: "Vietnamese" },
            ]}
            value={formData.languages}
            onChange={(value) => handleChange("languages", value)}
            error={errors.languages}
            shadow={true}
            showSearch
            multiple
          />
          <FormFieldSet
            title="Comments"
            type="textArea"
            placeholder="Comments"
            rows={3}
            value={formData.comments}
            onChange={(value) => handleChange("comments", value)}
            error={errors.comments}
            shadow={true}
          />
        </div>
      </div>
      <div className="mt-3">
        <h6>Organizational Information</h6>
        <div className="xl:mr-20 2xl:mr-40 grid lg:grid-cols-3  xl:grid-cols-4 grid-cols-2 gap-x-4 gap-y-5 mt-2">
          {/* <FormFieldSet
            title="Industry"
            placeholder="Select"
            type="select"
            options={[
              { label: "IT", value: "IT" },
              { label: "Finance", value: "Finance" },
              { label: "Healthcare", value: "Healthcare" },
            ]}
            value={formData.organizationalIndustry}
            onChange={(value) => handleChange("organizationalIndustry", value)}
            error={errors.organizationalIndustry}
          /> */}
          <FormFieldSet
            title="No of positions"
            placeholder="Select"
            type="text"
            value={formData.noOfPosition}
            onChange={(value) => handleChange("noOfPosition", value)}
            error={errors.noOfPosition}
            shadow={true}
          />
          <FormFieldSet
            title="Tax Terms"
            placeholder="Select"
            type="select"
            options={[
              { label: "1099", value: "1099" },
              { label: "C2C", value: "C2C" },
              { label: "Full Time", value: "Full Time" },
              { label: "In-cop", value: "In-cop" },
              { label: "Intern", value: "Intern" },
              { label: "Other", value: "Other" },
              { label: "Part Time", value: "Part Time" },
              { label: "W-2", value: "W-2" },
            ]}
            value={formData.taxTerms}
            onChange={(value) => handleChange("taxTerms", value)}
            error={errors.taxTerms}
            shadow={true}
            showSearch
          />
          <FormFieldSet
            title="Assigned To"
            placeholder="Select"
            // type="select"
            type="bdmUsers"
            // options={[
            //   { label: "User 1", value: 1 },
            //   { label: "User 2", value: 2 },
            //   { label: "User 3", value: 3 },
            // ]}
            value={formData.assignedTo}
            onChange={(value) => handleChange("assignedTo", value)}
            error={errors.assignedTo}
            shadow={true}
            showSearch
          />
          <FormFieldSet
            title="Notify To"
            placeholder="Select"
            // type="select"
            multiple
            // type="bdmAndRecruitersUsers"
            type="select"
            // options={[
            //   { label: "User 4", value: 1 },
            //   { label: "User 5", value: 2 },
            //   { label: "User 6", value: 3 },
            // ]}
            options={allRecruiters}
            value={formData.notifyTo}
            onChange={(value) => handleNotifyToChange(value)}
            // onChange={(value) => {
            //   handleChange("notifyTo", value)
            //   // console.log("notify",value)
            // }}
            error={errors.notifyTo}
            shadow={true}
            showSearch
          />
        </div>
      </div>
      <div className="mt-10">
        <CkTextEditor value={jobDescription} onChange={setJobDescription} />
      </div>
      <div className="flex gap-2 justify-end mt-10 mb-5">
        <Button
          title={"Closed"}
          variant="outlined"
          color="black"
          onClick={onClose}
        />
        <Button title={"Save as a Draft"} variant="outlined" />
        <Button
          title={"Submit Application"}
          onClick={handleSubmitApplication}
        />
      </div>

      <Modal
        isOpen={botConfirmModal}
        title="Confirm Bot Assignment"
        onClose={() => {
          setBotConfirmModal(false);
          setPendingBotAssignment(null);
          setMaximumCalls(null);
        }}
        width="max-w-md"
        zIndex={100}
      >
        <div className="flex flex-col gap-6 p-4 pt-2">
          <FormFieldSet
            type="number"
            title="Maximum calls"
            placeholder="Enter limit"
            value={maximumCalls}
            onChange={(value) => setMaximumCalls(value)}
          />
          {/* <FormFieldSet
            type="number"
            title="Maximum Radius for talent match"
            placeholder="Enter limit"
            value={talentMatchRadius}
            onChange={(value) => setTalentMatchRadius(value)}
          /> */}
          <p className="text-gray-700">
            Are you sure you want to assign an AI Bot Recruiter to this job? Once
            assigned, it will actively process applications according to its AI
            settings.
          </p>
          <div className="flex justify-end gap-3 outline-none">
            <Button
              title="Cancel"
              variant="outlined"
              onClick={() => {
                setBotConfirmModal(false);
                setPendingBotAssignment(null);
                setMaximumCalls(null);
                // setTalentMatchRadius(50);
              }}
            />
            <Button
              title="Confirm"
              onClick={() => {
                handleNotifyToChange(pendingBotAssignment, true);
                setBotConfirmModal(false);
                setPendingBotAssignment(null);
              }}
            />
          </div>
        </div>
      </Modal>

      <Backdrop isOpen={isLoading || loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default AddJobPost;
